export const Layout = {
  margin: '0 5%',
  padding: '36px 0',
  maxWidth: 1280
};

export const Breakpoint = {
  large: 1024,
  medium: 840,
  inBetween: 700,
  small: 450
};
